import React, { ReactNode } from "react";
import { Chip } from "@mui/material";

export const ReadOnlyInputStatusChip = ({ label, backgroundColor }: { label: ReactNode; backgroundColor?: string }) => (
  <Chip
    label={label}
    size="small"
    sx={({ palette }) => ({
      backgroundColor,
      color: backgroundColor && palette.getContrastText(backgroundColor),
      px: 0,
    })}
  />
);
